import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import TillIcon from '@material-ui/icons/MoveToInbox'
class TillForm extends Component {
  static propTypes = {
    hiboutikAccount: PropTypes.string.isRequired,
    onRef: PropTypes.func
  }
  state = {
    iframe: true,
    disabled: false
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this)
    }
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(void 0)
    }
  }
  handleSubmitClick = e => {
    this.setState({ iframe: true, disabled: true })
    this.refs.print_form.submit()
  }
  handleLoaded = e => {
    this.setState({ iframe: false, disabled: false })
  }
  render() {
    const { hiboutikAccount, onRef } = this.props
    return (
      <div>
        {!onRef && (
          <Button
            color="primary"
            variant="raised"
            disabled={this.state.disabled}
            onClick={this.handleSubmitClick}>
            <TillIcon color="inherit" />
          </Button>
        )}
        <form
          ref="print_form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/?print`}
          target="hbIframe">
          <input type="hidden" name="action" value="ouvrir_tiroir_caisse" />
          <input type="hidden" name="xqk123pop_onar" value="0" />
        </form>
        {this.state.iframe && (
          <iframe
            title="PrintIframe"
            onLoad={this.handleLoaded}
            ref="hbIframe"
            name="hbIframe"
            hidden
          />
        )}
      </div>
    )
  }
}
export default TillForm



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/TillForm.js